<template>
  <div class="avatar-wrapper" v-intro="'<strong>Persönliche Daten</strong><br><br>Oben rechts sehen Sie sich als Kontoinhaber.<br>Wenn Sie auf den Pfeil neben Ihren Namen klicken, finden Sie den Link zum Ausloggen und zu Einstellung, wo Sie Ihre persönlichen Daten verwalten können. Einstellungen finden Sie auch in der Navigation. Ändern Sie dort Ihre Mobilnummer, falls nötig.'" v-intro-step="3" v-intro-position="'left'">
    <b-dropdown right :text="currentUser.fullname" dropdown-left variant="light" class="avatar-dropdown">
      <b-dropdown-text>
        {{currentUser.email}}
      </b-dropdown-text>
      <b-dropdown-divider></b-dropdown-divider>
      <b-dropdown-item to="/einstellungen">
        <span class="icon-settings"></span> Einstellungen
      </b-dropdown-item>
      <b-dropdown-item to="/firmenkonto" v-if="isOrganisationAccount">
        <span class="icon icon-office"></span> Firmenkonto
      </b-dropdown-item>
      <b-dropdown-item to="/hilfe">
        <span class="icon-help"></span> Hilfe
      </b-dropdown-item>
      <b-dropdown-divider></b-dropdown-divider>
      <b-dropdown-item @click="onLogout" class="logout-item">
        <span class="icon-logout"></span> Ausloggen
      </b-dropdown-item>
    </b-dropdown>
    <span class="avatar rounded-circle">
      <strong>
        {{currentUser.initials}}
      </strong>
    </span>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'

  export default {
    computed: {
      ...mapState({
        isOrganisationAccount: state => state.user.currentUser.isOrganisationAccount
      }),
      ...mapGetters({ currentUser: 'user/CURRENT_USER' })
    },
    methods: {
      async onLogout () {
        this.hasUnknownError = false
        this.hasError = false

        this.$store.dispatch('user/LOGOUT').finally(() => {
          this.$router.push({ path: '/' }).catch(() => {})
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .avatar-wrapper::v-deep{
    display: flex;
    float: right;

     @include media-breakpoint-down(md) {
        display: none;
     }

    a{
      text-decoration: none;
    }

    .btn.btn-light{
      padding-left: 0;
      background: none !important;
      border: none !important;
      outline: none !important;
      box-shadow: none !important;
    }
  }
  .avatar{
    border: 2px solid $magenta;
    width: 38px;
    height: 38px;
    color: $magenta;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
<style lang="scss">
  .logout-item .dropdown-item{
    color: $magenta;

    &:active {
      background-color: $white;
    }
  }
</style>
